import { faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HumbergerMenu from '../HumbergerMenu/Index'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useGetNotificationsQuery } from '../../features/promotions/promotionApiSlice'

// import { CartContext } from '../../../features/cartContext/CartContext';

const Promotion = () => {

  const {
    data: notifications,
    isLoading,
    isSuccess,
    isError,
    error
  } = useGetNotificationsQuery('promotionsList', {
    pollingInterval: 6000000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  })

  // console.log(notifications)

  const prom = 'Join the Megenagna EQUB club'
  const prom_1 = '& get  discount off your next visit'

  const [onCLose, setOnCLose] = useState(false);
  const [advertise, setAdvertise] = useState(null)

  let content

  if (isLoading) content = <p>Loading...</p>

  if (isError) {
    // content = <p className="errmsg">{error?.data?.message}</p>
    content = <div style={{ color: "red" }}>Loading...</div>
  }


  if (isSuccess) {

    const { ids } = notifications

    // console.log("=========")
    const dataResponse = ids.map((val) => {
      return notifications.entities[val]
    })

    // console.log(dataResponse)
    var myData = Object.keys(dataResponse).filter(key => dataResponse[key].display === true)

    // console.log(myData)
    var randomVal = [Math.floor(Math.random() * myData.length)]
    // console.log(randomVal)
    // console.log(dataResponse[myData[randomVal]].description)
    // var file__ = myData[Math.floor(Math.random() * myData.length) + 1]
    // console.log(file__.length === 1 ? file__[0].description : file__.description)

    content = (
      <> {!onCLose &&
        < section id="primo" className=' bg-mainColor py-2  items-end'>
          <div className="grid grid-cols-12 justify-between">
            {/* left item */}
            <div className='hidden md:block md:col-span-1 '></div>
            <div className='cursor-pointer ml-1 col-span-9 md:col-span-8 text-[14px] flex-row md:flex  text-white font-Avenir items-center text-center md:text-[16px] md:font-Avenir'>

              {myData.length > 0 && dataResponse[myData[randomVal]].description}

            </div>

            <div className='col-span-3 md:col-span-3 items-left text-right font-bold mx-4'>
              <button aria-label='close menu' className='size-6 text-white' onClick={() => setOnCLose(true)}>
                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' className='lucide lucide-x'>
                  <path d='M18 6 6 18M6 6l12 12' />
                </svg>
              </button>
            </div>
          </div>

        </section >
      }
      </>

    )
  }

  return content
}

export default Promotion
